module.exports = "<div data-placeholder></div>\n"